import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import Link from '@material-ui/core/Link';

import LanguageSelector from '../../layout/components/LanguageSelector/LanguageSelector';
import logoLandscape from '../../logo_landscape.png';
import Item from './components/Item/Item';
import ResultWidget from './components/ResultWidget/ResultWidget';
import useCo2Calculation from './hooks/useCo2Calculation';
import useItems from './hooks/useItems';
import useSavingScore from './hooks/useSavingScore';
import { AddProductButton, AddProductContainer, Container, DisclaimerText, LanguageSelectorWrapper, Logo, Subtitle } from './styled';

const Co2SimulatorPage = () => {
    const { items, addItem, removeItem, updateItem } = useItems();

    const { t } = useTranslation();

    const score = useSavingScore({ items });
    const totalSavedCo2 = useCo2Calculation({ items, type: 'saving' });

    return (
        <Container>
            <Logo alt='PFC logo' src={logoLandscape} />

            <Subtitle variant='body1' >
                {t('pages.co2_external_tool.subtitle')}
            </Subtitle>

            {items.map((item) => {
                return <Item key={item.id} data={item} updateItem={updateItem} removeItem={removeItem} count={items.length} />;
            })}

            <AddProductContainer>
                <AddProductButton variant='contained' color='primary' onClick={addItem} >
                    {t('pages.co2_external_tool.add_item')}
                </AddProductButton>
            </AddProductContainer>

            <ResultWidget itemsCount={items.length} savedCo2={totalSavedCo2} score={score} />

            {[
                'https://www.plasticfreecertification.org/certification-process/',
                'https://www.plasticfreecertification.org/how-much-co2-do-we-save-by-eliminating-single-use-plastics/'
            ].map((link, idx) => {
                return (
                    <DisclaimerText variant='body2'>
                        <Trans i18nKey={'pages.co2_external_tool.disclaimer_' + (idx + 1)}>
                            _<Link href={link} target='_blank' />_
                        </Trans>
                    </DisclaimerText>
                );
            })}

            <LanguageSelectorWrapper>
                <LanguageSelector />
            </LanguageSelectorWrapper>
        </Container>
    );
};

export default Co2SimulatorPage;